define("@latermedia/ember-later-analytics/helpers/get-error-type", ["exports", "@ember/component/helper", "@latermedia/ember-later-analytics/utils/state-types"], function (_exports, _helper, _stateTypes) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _default = _exports.default = (0, _helper.helper)(_ref => {
    let [state] = _ref;
    if (state?.type !== _stateTypes.ERROR) {
      return null;
    }
    return state?.metadata?.errorType;
  });
});